export function IndiaMapBackdrop() {
  return (
    <div className="pointer-events-none fixed inset-0 z-0 flex items-center justify-center overflow-hidden" aria-hidden="true" data-testid="india-map-backdrop">
      <img
        src="/india-outline.svg"
        alt=""
        className="h-[88vh] max-h-[88vh] w-auto max-w-[92vw] object-contain opacity-[0.09]"
        style={{ filter: "invert(32%) sepia(60%) saturate(1800%) hue-rotate(200deg) brightness(90%)" }}
      />
    </div>
  );
}
